import React from 'react';
import PropTypes from 'prop-types';

import './Tags.sass';

export default class Tags extends React.PureComponent {
  render() {
    const {tags} = this.props;

    return(
      <div className="tag-list">
        {tags.map(tag => (
          <span key={tag} className="tag-list__tag">{tag}</span>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/tags/Tags.js